import { createSlice } from '@reduxjs/toolkit';
import extraReducers from 'src/redux/properties/extra-reducers';
import reducers from 'src/redux/properties/reducers';
import { propertiesInitialState } from './types';

const propertiesSlice = createSlice({
  name: 'properties',
  initialState: propertiesInitialState,
  reducers,
  extraReducers: (builder) => extraReducers(builder),
});

export const {
  clearPropertyListData,
  updatePropertyDetails,
  changePropertyDetailsTab,
  setMarketAssignmentFilter,
  selectPreferredVendorCategory,
  reorderDefaultVendors,
  addDefaultVendor,
  removeDefaultVendor,
  reorderSubVendors,
  addSubVendor,
  removeSubVendor,
  customizeSubCategory,
  resetSubCategory,
  restoreDefaultVendors,
  restoreSubCategory,
  restoreSubVendors,
  clearPreferredVendors,
  addPreferredVendorCategory,
  removePreferredVendorCategory,
  syncOverriddenVendorsCount,
} = propertiesSlice.actions;

export default propertiesSlice.reducer;
